/**
 * Mando UI initialisation
 */

/* eslint-disable */
import Vue from "NodeModules/vue/dist/vue.min.js";

// Simple observable event bus to allow communication between components
Vue.prototype.$eventBus = new Vue();

import moment from "NodeModules/moment/moment";
import polyfillClosest from '../polyfill';
import navigation from 'Components/geneco/navigation/mando-ui.navigation';
import search from 'Components/geneco/search/mando-ui.search';
import cookieBanner from 'Components/geneco/_cookie/mando-ui.cookie';
import share from 'Components/geneco/share/mando-ui.share';
import table from 'Components/geneco/_rte-table/mando-ui.rte-table';
import tabs from 'Components/geneco/tabs/mando-ui.tabs';

import videoHero from 'Components/geneco/hero/mando-ui.video-hero';
import heroCarousel from 'Components/geneco/hero/mando-ui.hero-carousel';

import searchResults from 'Components/geneco/results/SearchResults.vue';

import communitySearchResults from 'Components/geneco/community-search-results/communitySearchResults.vue';
import resources from 'Components/geneco/resources/Resources.vue';

import headerAltOne from 'Components/geneco/header/header';
import toTop from 'Components/geneco/_to-top/to-top';

document.addEventListener('DOMContentLoaded', () => {
  // Add JS helper class
  document.getElementsByTagName('html')[0].classList.remove('no-js');
  document.getElementsByTagName('html')[0].classList.add('has-js'); 

  //* Polyfill
  polyfillClosest();

  // Components
  navigation();
  headerAltOne();
  search();
  cookieBanner();
  share();
  table();
  videoHero();
  heroCarousel();
  tabs();
  toTop();

  const searchResultsEl = document.querySelector('#search-results');
  const communitySearchResultsEl = document.querySelector('#community-search');
  const resourcesEl = document.querySelector('#resources');

  Vue.filter('formatDate', (value) => {
    if (!value) {
      return '';
    }
    return moment(value).format('DD/MM/YY');
  });

  Vue.filter('formatFileSize', (value) => {
    return `${(value / Math.pow(1024, 1)).toFixed(2)}kB`;
  });

  Vue.filter('booleanToYesNo', value => ((value) ? 'Yes' : 'No'));

  if (searchResultsEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#search-results',
      render: h => h(searchResults, {
        props: {
          categories: JSON.parse(searchResultsEl.dataset.categories),
          componentId: searchResultsEl.dataset.componentId,
          siteId: searchResultsEl.dataset.siteId,
        },
      }),
    });
    /* eslint-enable */
  }

  if (communitySearchResultsEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#community-search',
      render: h =>
        h(communitySearchResults, {
          props: {
            options: JSON.parse(communitySearchResultsEl.dataset.options),
            searchConfig: communitySearchResultsEl.dataset.searchConfig,
            componentId: communitySearchResultsEl.dataset.componentId,
            siteId: communitySearchResultsEl.dataset.siteId,
            paging: communitySearchResultsEl.dataset.paging
          }
        })
    });
    /* eslint-enable */
  }

  if (resourcesEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#resources',
      render: h =>
        h(resources, {
          props: {
            options: JSON.parse(resourcesEl.dataset.options),
            searchConfig: resourcesEl.dataset.searchConfig,
            componentId: resourcesEl.dataset.componentId,
            siteId: resourcesEl.dataset.siteId
          }
        })
    });
    /* eslint-enable */
  }
});


// WEBPACK FOOTER //
// ./src/scripts/brands/geneco.js